import React from 'react'
import NextLink from 'next/link'
import { Link, Button } from 'components/generic/PrimaryButton/styles'

const PrimaryButton = ({ href, children, ...rest }) => {
  return href ? (
    <NextLink href={href} passHref>
      <Link {...rest}>{children}</Link>
    </NextLink>
  ) : (
    <Button {...rest}>{children}</Button>
  )
}

export default PrimaryButton
